import React, { useState,useEffect } from 'react';
import axios from 'axios';
import { showToast,ToastMessage } from '../../Shared/ToastMessage';
import { baseUrl } from '../../../api/common';
import dayjs from "dayjs";
const PushNotificationAdd = ({fetchPushNotificationData,addPopupStatus, handleAddPopup, eventType, updateData}) => {

  const [updateId, setUpdateId] = useState("");
  const dateFormatList = "YYYY-MM-DD";
  const [formValues, setFormValues] = useState({
    title:'',
    description:''
  });

  const [errors, setErrors] = useState({
    title:'',
    description:''
  });

  const handleInputChange = (field, value) => {
    setFormValues({ ...formValues, [field]: value });
  };    


  const validate = () => {
    const newErrors = {
      title:'',
      description:''
    };  
    if (!formValues.title.trim()) {
      newErrors.title = 'Title cannot be empty';
    }
    if (!formValues.description.trim()) {
      newErrors.description = 'Message cannot be empty';
    }      
    setErrors(newErrors);
    return Object.values(newErrors).every((error) => error === '');
  };  

  const clearInputValues = () => {
    setErrors({ 
      title:'',
      description:''
    });
    setFormValues({
      title:'',
      description:''
    });
    handleAddPopup(false);
  };  

  const addUpdatePushNotification = async (sendStatus) => {
    if (validate()) {
      console.log('Post Data:', formValues); 
      try {
        const requestData = {
          ...formValues,
          ...{notify_from: localStorage.getItem('loginUserId') || '',
              notify_to: 0,
              send_status: sendStatus},
          // ...(eventType === "Update" && { id: updateId }),
        };
        console.log("Update requestData Data:", requestData);
        const response = await axios.post(
          `${baseUrl}/api/push_notification_add`,
          requestData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: localStorage.getItem('access_token'),
            },
          }
        );
        if (response.data.status) {
          showToast(response.data.message, 'success');
          fetchPushNotificationData();
          clearInputValues();
        } else {
          showToast(response.data.message, 'error');
        }
      } catch (error) {
        console.error("Error during submission:", error);
        showToast("A network error occurred, or the server is temporarily busy. Please try again later.", "error");
      }
    }else {
      showToast("Please fill in the required details.", "error");
    }
  };

  useEffect(() => {
    if (eventType === "Update" && updateData) {
      console.log("Update Data:", updateData);
      setUpdateId(updateData.id);
      setFormValues({
        title: updateData.title || '',
        description: updateData.description || ''
      });
    }else{
      setErrors({
        title:'',
        description:''
      });
      setFormValues({
        title:'',
        description:''
      });  
    }
  }, [eventType, updateData, addPopupStatus]);

  return (
    <>
    <ToastMessage/>    
    {addPopupStatus && (
      <div
        className={`extraspace_search_div search_div${addPopupStatus ? ' open' : ''}`}
      >
        <div className="card member_master_sidebar_scrool">
          <div className="member_edit_pop_flex mb-3 text-end">
            <h3>{eventType} Push Notification</h3>
            <div className="input-group-append">
              <span
                onClick={() => clearInputValues()}
                className="search_toggle btn btn-danger"
              >
                <i className="fa fa-times" />
              </span>
            </div>
          </div>
          <div className="table-responsive">
            <div className="body application_body_side">
              <div>             
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group pos_relative">
                        <label>Title <span className="text-danger">*</span></label>
                        <input
                          type="text"
                          className={`form-control ${errors.title?"red_border":''}`}
                          value={formValues.title}
                          onChange={(e) => handleInputChange('title', e.target.value)} 
                          required
                        />
                        {errors && (                          
                            <p className="text-danger pos_abos">{errors.title}</p>                          
                        )}
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group pos_relative">
                        <label>Message <span className="text-danger">*</span></label>
                        <textarea
                          rows={4}
                          type="text"
                          className={`form-control ${errors.description ? "red_border" : ""}`}
                          value={formValues.description}
                          onChange={(e) => handleInputChange("description", e.target.value)}
                        />
                        {errors && (                          
                            <p className="text-danger pos_abos">{errors.description}</p>                          
                        )}
                      </div>
                    </div>
                    <div className="col-md-12 member_button_flex">
                      <button onClick={() => addUpdatePushNotification(2)} className="btn btn-outline-info">
                       Save & Send
                      </button>
                     <button onClick={() => addUpdatePushNotification(1)} className="btn btn-outline-info">
                       Save
                      </button>
                      <a
                        onClick={() => clearInputValues()}
                        className="btn btn-outline-danger"
                      >
                        Close
                      </a>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )}
    </>
  );
};

export default PushNotificationAdd;
